
module.exports = {
    List: require('./List'),
    ListPatches: require('./ListPatches'),
    Map: require('./ImmyMap'),
    MapPatches: require('./MapPatches')
};



//////////////////
// WEBPACK FOOTER
// ./~/immy/src/immy.js
// module id = 327
// module chunks = 0